import { C } from "../../styles/theme";
import PBtn from "../common/PBtn";

export default function CompareBar({ items, onRemove, onClear, onCompare }) {
  if (!items || !items.length) return null;
  return (
    <div style={{ position: "fixed", bottom: 0, left: 0, right: 0, background: "#fff", borderTop: `2px solid ${C.border}`, boxShadow: "0 -4px 18px rgba(0,0,0,.1)", zIndex: 400, padding: "11px 22px" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto", display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
        <div style={{ fontWeight: 700, color: C.blue, fontSize: 13, flexShrink: 0 }}>Compare ({items.length}/3):</div>
        <div style={{ display: "flex", gap: 8, flex: 1, flexWrap: "wrap" }}>
          {items.map(p => (
            <div key={p.id} style={{ display: "flex", alignItems: "center", gap: 6, background: C.bg, border: `1px solid ${C.border}`, borderRadius: 7, padding: "5px 9px" }}>
              <span style={{ fontSize: 12.5, fontWeight: 600, color: C.blue }}>{p.name}</span>
              <button onClick={() => onRemove(p.id)} style={{ background: "none", border: "none", cursor: "pointer", color: C.red, fontSize: 13, lineHeight: 1, padding: 0 }}>x</button>
            </div>
          ))}
          {Array(3 - items.length).fill(0).map((_, i) => (
            <div key={i} style={{ display: "flex", alignItems: "center", background: "#f8fafc", border: "1.5px dashed " + C.border, borderRadius: 7, padding: "5px 12px", color: "#94a3b8", fontSize: 11 }}>+ Add</div>
          ))}
        </div>
        <div style={{ display: "flex", gap: 7, flexShrink: 0 }}>
          <button onClick={onClear} style={{ background: "#f1f5f9", color: C.gray, border: "none", padding: "8px 14px", borderRadius: 7, fontWeight: 600, fontSize: 12.5, cursor: "pointer" }}>Clear</button>
          <PBtn onClick={onCompare} extra={{ padding: "8px 18px", fontSize: 13, opacity: items.length < 2 ? .5 : 1, cursor: items.length < 2 ? "not-allowed" : "pointer" }}>Compare Now</PBtn>
        </div>
      </div>
    </div>
  );
}
